import { msg } from '@lingui/macro';

export default {
  pageTitles: {
    welcome: msg`myVoyage Personalized Enrollment Guidance: Sign In`,
  },
};
